<template>
  <el-drawer title="会员补助填写" :before-close="close" :visible.sync="drawerVisible" @opened="drawOpen" direction="rtl"
    :wrapperClosable='false' class="demo-drawer" ref="drawer">
    <div class="demo-drawer__content">
      <el-form ref="form" :model="form" :label-width="formLabelWidth" v-loading="loading" element-loading-text="提交中..."
        class="formbirth" size="small">
        <el-form-item label="姓名" prop="MemberName" :rules="[
            { required: true, message: '姓名不能为空', trigger: 'blur' },
          ]">
          <el-input v-model="form.MemberName" autocomplete="off" placeholder="请输入姓名" readonly></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="MemberCode" :rules="[
            { required: true, message: '账号不能为空', trigger: 'blur' },
          ]">
          <el-input v-model="form.MemberCode" autocomplete="off" placeholder="请输入账号" readonly></el-input>
        </el-form-item>
        <el-form-item label="填写日期" prop="fillInDate" :rules="[
            { required: true, message: '填写日期不能为空', trigger: 'blur' },
          ]">
          <el-date-picker v-model="form.fillInDate" type="date" placeholder="请输入填写日期" readonly class="w100"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="填写类型" prop="fillInType" :rules="[
            { required: true, message: '补助类型不能为空', trigger: 'blur' },
          ]">
          <el-input v-model="form.fillInType" autocomplete="off" placeholder="请输入补助类型" readonly></el-input>
        </el-form-item>
        <el-form-item label="确诊日期" prop="EventDate" :rules="[
            {
              required: true,
              message: '确诊日期不能为空',
              trigger: 'blur',
            },
          ]">
          <el-date-picker v-model="form.EventDate" type="date" placeholder="请输入确诊日期" class="w100" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="图片资料" prop="FaceImage" :rules="[
            { required: true, message: '附件不能为空', trigger: ['blur','change'] },
          ]">
          <el-upload ref="upload" class="avatar-uploader" action="#" accept=".jpeg,.png,.jpg,.pdf,.docx,.doc,xlsx,.xls"
            :before-upload="beforeAvatarUpload" :http-request="uploadFile" :before-remove="beforeRemove"
            :on-remove="handleRemove" :limit="10" list-type="picture-card"
            :on-exceed="handleExceed">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="原因" prop="Remark" :rules="[
            { required: true, message: '原因不能为空', trigger: 'blur' },
          ]">
          <el-input type="textarea" maxlength="200" show-word-limit v-model="form.Remark" autocomplete="off" placeholder="请输入原因" rows="3"></el-input>
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button size="small" type="primary" @click="submitHandle" :loading="loading" :disabled="disable">
          {{ loading ? "提交中 ..." : "确 定" }}</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
  import * as indexService from "@/api/sys/index";
  import dayjs from "dayjs";
  import rules from "@/libs/rules";
  const defualtForm = {
    MemberName: "",
    MemberCode: "",
    fillInDate: "",
    fillInType: "",
    FaceImage: "",
    Remark: "",
    EventDate: "",
  };
  export default {
    name: "editSubsidyForm",
    props: {
      subsidy: Object,
      checked: Object,
      value: Boolean,
    },
    data() {
      return {
        loading: false,
        rulesUtils: rules,
        drawerVisible: false,
        formLabelWidth: "100px",
        form: Object.assign({}, defualtForm),
        disable: false,
        filetypes: ["application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/msword"
        ], //文件属性
        fileIds: [], //文件id
        index: 0,
        fileList: [],
        pickerOptions: {
          //日期选择
          disabledDate(date) {
            return date.getTime() > Date.now();
          },
        },
      };
    },
    watch: {
      value(val) {
        this.drawerVisible = val;
      },
      drawerVisible(val) {
        this.$emit("input", val);
      },
    },
    computed: {
      unitname() {
        return this.$store.state.d2admin.userInfo.userinfo;
      },
    },
    methods: {
      drawOpen() {
        this.$refs.form.resetFields();
        this.form.MemberName = this.unitname.uInfo.Name
        this.form.MemberCode = this.unitname.uInfo.AdAccount
        this.form.fillInDate = dayjs().format("YYYY-MM-DD")
        this.form.fillInType = this.checked.name
        indexService.GetIsMember().then((data) => {
          if (data.data.isMember == false) {
            this.$message.warning("此账号不是会员,无法申请");
            setTimeout(() => {
              this.drawerVisible = false;
            }, 2000);
          } else {
            this.GetSubsidyApplyStatus();
          }
        });

      },
      GetSubsidyApplyStatus() {
        let query = {
          type: this.checked.name,
          shortTitle: "会员补助填写",
        };
        indexService.GetSubsidyApplyStatus(query).then((data) => {
          if (data.data.status != -1) {
            this.$message.warning(
              data.data.Actor ? data.data.Actor : "此账号已无法提交"
            );
            this.disable = true;
          } else {
            this.disable = false;
          }
        });
      },
      submitHandle() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.loading = true;
            let form = {
              childrenData: [],
              dataId: 0,
              mainData: {
                MemberName: this.form.MemberName,
                MemberCode: this.form.MemberCode,
                fillInDate: this.form.fillInDate,
                fillInType: this.form.fillInType,
                FaceImage: this.form.FaceImage,
                Remark: this.form.Remark,
                EventDate: this.form.EventDate,
                Substation: this.unitname.uInfo.Substation,
                JoinMemberDay: this.unitname.uInfo.JoinMemberDay,
                GroupName: this.unitname.uInfo.GroupName,
              },
              shortTitle: this.checked.submitTitle,
            };
            indexService
              .addQuestionData({
                ...form,
              })
              .then((data) => {
                this.$message.success("申请成功！");
                this.drawerVisible = false;
                this.$emit("submit");
                this.close();
              })
              .catch((e) => {
                this.loading = false;
              });
          } else {
            return false;
          }
        });
      },
      beforeAvatarUpload(file) {
        let isLt2M = file.size < 1024 * 5120;
        let isJPG = ["image/jpeg", "image/png", "image/jpg","image/gif"].includes(file.type);

        if (!isJPG) {
          this.$message.error("上传图片只能是 JPG/PNG/JPEG/GIF 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 5MB!");
        }
        return isJPG && isLt2M;
      },
      handleExceed() {
        this.$message.warning("只能上传10个");
      },
      beforeRemove(file) {
        let fileList = this.$refs['upload'].uploadFiles;
        let index = fileList.findIndex(fileItem => {
          return fileItem.uid === file.uid
        });
        this.index = index;
        // 本人只能删除本人的文件
        if (file.Creator && util.cookies.get('uuid') != file.Creator) {
          this.$message.warning("只能删除自己上传的文件");
          return false;
        }
        return true;
      },
      handleRemove(file, fileList) {
        if (this.fileIds) {
          this.fileIds.forEach((v, i) => {
            if (this.index == i) {
              this.fileIds.splice(i, 1);
              this.fileList.splice(i, 1);
              this.form.FaceImage = this.fileIds.toString();
            }
          })
        }
      },
      //上传图片
      uploadFile(item) {
        let _this = this;
        let formdata = new FormData();
        formdata.append("image", item.file);
        indexService
          .uploadFile(formdata, item.file.name)
          .then((data) => {
            this.$message({
              type: "success",
              message: "图片上传成功!",
            });
            item.onSuccess();
            this.fileIds.push(data.data.filepath);
            this.fileList.push({
              name: data.data.filename,
              url: this.$apiUrl + data.data.filepath
            })
            this.form.FaceImage = this.fileIds.toString();
          })
          .catch((error) => {
            item.onError();
          });
      },
      close() {
        this.$refs.form.resetFields();
        this.drawerVisible = false;
        this.fileIds = [];
        this.fileList = [];
        this.loading = false;
      },
    },
  };
</script>